// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__ZYUi7","box":"style_box__NHAgZ","active":"style_active__dJCJk","title":"style_title__2pJ4b","item":"style_item__UGQKy"};